"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var add_trigger_1 = require("./add-trigger");
var mouseover_focusable_1 = require("./mouseover-focusable");
function dispatch(elt) {
    if (elt.dataset.phocusAction) {
        add_trigger_1.addTrigger(elt);
    }
    if (elt.dataset.phocusOnMouseover) {
        mouseover_focusable_1.makeMouseoverFocusable(elt);
    }
    var children = elt.querySelectorAll("[data-phocus-action]:not([data-phocus-action=''])");
    Array.from(children).forEach(function (e) {
        if (!(e instanceof HTMLElement))
            return;
        add_trigger_1.addTrigger(e);
    });
    children = elt.querySelectorAll("[data-phocus-on-mouseover]:not([data-phocus-on-mouseover=''])");
    Array.from(children).forEach(function (e) {
        if (!(e instanceof HTMLElement))
            return;
        mouseover_focusable_1.makeMouseoverFocusable(e);
    });
}
exports.dispatch = dispatch;
function undispatch(elt) {
    if (elt.dataset.phocusAction) {
        add_trigger_1.removeTrigger(elt);
    }
    if (elt.dataset.phocusOnMouseover) {
        mouseover_focusable_1.removeMouseoverFocusable(elt);
    }
    var children = elt.querySelectorAll("[data-phocus-action]:not([data-phocus-action=''])");
    Array.from(children).forEach(function (e) {
        if (!(e instanceof HTMLElement))
            return;
        add_trigger_1.removeTrigger(e);
    });
    children = elt.querySelectorAll("[data-phocus-on-mouseover]:not([data-phocus-on-mouseover=''])");
    Array.from(children).forEach(function (e) {
        if (!(e instanceof HTMLElement))
            return;
        mouseover_focusable_1.removeMouseoverFocusable(e);
    });
}
exports.undispatch = undispatch;
//# sourceMappingURL=dispatch.js.map